import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Dialog } from "@mui/material";
import React from "react";

const ApiLoder = () => {
  return (
    <>
      <div className="spinner_overlay"></div>
      <div className="spinner-box">
        <img
          src="/image/loder.gif"
          alt=""
          className="loading-icon"
          loading="lazy"
        />
      </div>
    </>
  );
};

export const SectionLoader = ({ height = 120, text = "Loading..." }) => (
  <div
    className="d-flex flex-column align-items-center justify-content-center text-muted"
    style={{ height }}
  >
    <span className="spinner-border spinner-border-lg" role="status" />
    {text && <small className="mt-2">{text}</small>}
  </div>
);

export const ButtonSpinner = () => (
  <span
    className="spinner-border spinner-border-sm ms-2"
    role="status"
    aria-hidden="true"
  />
);

const SuccessMessage = (message) => {
  setTimeout(
    () =>
      toast.success(message, {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      }),
    10,
  );
};

const ErrorMessage = (message) => {
  toast.error(message, {
    position: "top-center",
    autoClose: 2000,
    theme: "colored",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

const CustomMessages = {
  required: "required_field",
  email: "email_field",
  min: "min_field",
  max: "max_field",
  numeric: "numeric_field",
  alpha_num: "alpha_num_field",
  alpha_num_space: "alpha_num_space_field",
};

function SubmitButton({ onClick, disabled, text }) {
  return (
    <button
      disabled={disabled}
      type="button"
      onClick={onClick}
      className="btn blue-btn"
    >
      {text}
      {disabled && (
        <i className="fa fa-spinner fa-spin" style={{ marginLeft: "10px" }}></i>
      )}
    </button>
  );
}

const Delete = ({ open, handleClose, handleDelete, title, id, loder }) => {
  return (
    <>
      <Dialog
        open={open}
        fullWidth={true}
        maxWidth={"xs"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body logout-popup text-center">
              <span className="mx-auto">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={48}
                  height={48}
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.592 4.4881C25.306 3.6521 28 6.8441 28 10.0001V38.0001C28 41.1561 25.306 44.3481 21.592 43.5121C12.668 41.5041 6 33.5321 6 24.0001C6 14.4681 12.668 6.4961 21.592 4.4881ZM32.586 16.5861C32.9611 16.2112 33.4697 16.0005 34 16.0005C34.5303 16.0005 35.0389 16.2112 35.414 16.5861L41.414 22.5861C41.7889 22.9612 41.9996 23.4698 41.9996 24.0001C41.9996 24.5304 41.7889 25.039 41.414 25.4141L35.414 31.4141C35.0368 31.7784 34.5316 31.98 34.0072 31.9754C33.4828 31.9709 32.9812 31.7606 32.6104 31.3897C32.2395 31.0189 32.0292 30.5173 32.0247 29.9929C32.0201 29.4685 32.2217 28.9633 32.586 28.5861L35.172 26.0001H18C17.4696 26.0001 16.9609 25.7894 16.5858 25.4143C16.2107 25.0392 16 24.5305 16 24.0001C16 23.4697 16.2107 22.961 16.5858 22.5859C16.9609 22.2108 17.4696 22.0001 18 22.0001H35.172L32.586 19.4141C32.2111 19.039 32.0004 18.5304 32.0004 18.0001C32.0004 17.4698 32.2111 16.9612 32.586 16.5861Z"
                    fill="white"
                  />
                </svg>
              </span>
              <h3> Delete</h3>
              <p>
                Are your sure you want to delete{" "}
                <strong className="stongtag">{title}</strong> ?
              </p>
              <div className="save_btn">
                <button
                  type="button"
                  className="btn border-btn me-2"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn blue-btn"
                  disabled={loder}
                  onClick={() => {
                    handleDelete(id);
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};


const formatDate = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleDateString("en-GB", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
    });
};
const formatShortDate = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
    });
};

const SendConfirmModal = ({
  open,
  handleClose,
  onConfirm,
  title = "Confirm",
  message = "Are you sure?",
  confirmText = "Confirm",
  variant = "primary",
  icon = "send",
  loading = false,
}) => {
  const SendIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={48}
      height={48}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  );

  const WarningIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={48}
      height={48}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"xs"}
      aria-labelledby="send-confirm-title"
    >
      <div
        className="modal fade show"
        id="contactModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-modal="true"
        role="dialog"
        style={{ display: "block", backgroundColor: "#00000080" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body logout-popup text-center">
              <span className="mx-auto">
                {icon === "warning" ? <WarningIcon /> : <SendIcon />}
              </span>

              <h3>{title}</h3>

              <p>{message}</p>

              <div className="save_btn">
                <button
                  type="button"
                  className="btn border-btn me-2"
                  onClick={handleClose}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className={`btn ${variant === "danger" ? "btn-danger" : "blue-btn"}`}
                  onClick={onConfirm}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      {confirmText}
                      <span
                        className="spinner-border spinner-border-sm ms-2"
                        role="status"
                      />
                    </>
                  ) : (
                    confirmText
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}


const maskEmail = (email) => {
  if (!email || !email.includes("@")) return email || "";
  const [name, domain] = email.split("@");
  const visible = name.slice(0, 3);
  const masked = "*".repeat(Math.max(4, name.length - 3));
  const domTail = domain.length > 8 ? domain.slice(-7) : domain;
  return `${visible}${masked}@${domTail}`;
};


export {
  ApiLoder,
  ErrorMessage,
  SuccessMessage,
  CustomMessages,
  SubmitButton,
  Delete,
  SendConfirmModal,
  maskEmail,
  formatDate,
  formatShortDate
};
